Vue.component('adminTournament', {
  template: templates.adminTournament,
  data() {
      return {
          model: {
              hasResult: false,
              isLoading: false,
              edit: false,
              tournament: {
                  active: false,
                  name: null,
                  description: null,
                  players: null,
                  selectedOption: '',
                  battleOption: null,
                  autobattle: false,
                  multipleBattle: false,
                  faction: false,
                  innerFaction: false,
                  universalFaction: false
              },
              tournaments: [],
              option: [
                  { name: '' },
                  { name: 'Prime Cards Only' },
                  { name: 'Ultra Cards Only' },
                  { name: 'Legendary Cards Only' },
                  { name: 'Prime Plus Only' },
                  { name: 'Ultra Plus Only' },
                  { name: 'Legendary Plus Only' },
                  { name: 'Ultimate Cards Only' },
                  { name: 'Ultra Cards or less' },  
                  { name: 'Legendary Cards or Less' },  
                  { name: 'No Ultimates' },  
                  { name: 'No Augmentation' },  
                  { name: 'No Delta' },  
                  { name: 'No Limits' } 
              ],
              battle_options: [
                  { value: 'single', name: 'Single Battle' },
                  { value: '2v2', name: '2v2' },
                  { value: '3v3', name: '3v3' },
                  { value: '4v4', name: '4v4' }
              ],
              players: [
                  { value: '4', name: '4' },
                  { value: '8', name: '8' },
                  { value: '16', name: '16' },
                  { value: '32', name: '32' },
                  { value: '64', name: '64' },
                  { value: '128', name: '128' },
              ],
          },
          ws: null
      }
  },
  mounted() {
      const c = this
      c.get();
      c.connect();
  },
  beforeDestroy() {
      const c = this
      // Clean up WebSocket connection
      if (c.ws) {
          c.ws.close();
      }
  },
  methods: {
      connect() {
          const c = this

          try {
              c.ws = new WebSocket(utils.getWsUrl());
        
              c.ws.onmessage = (event) => {
                  // Handle incoming messages
                  console.log('WebSocket message:', event.data);
              };
        
              c.ws.onopen = () => {
                  console.log('WebSocket connection established');
              };
        
              c.ws.onclose = () => {
                  console.log('WebSocket connection closed');
              };
              
              c.ws.onerror = (error) => {
                  console.error('WebSocket error:', error);
              };
          } catch (error) {
              console.error('Failed to connect to WebSocket:', error);
          }
      },
      get() {
          const c = this

          c.model.isLoading = true;
          
          tournamentService.get()
              .then((response) => {
                  const data = {};
                  
                  for (let d of response.data) {
                      data[`${d.id}`] = d;
                  }
                  c.model.tournaments = data;
                  c.model.hasResult = true;
                  c.model.isLoading = false;
              })
              .catch((error) => {
                  console.error('Error fetching tournaments:', error);
                //   utils.alert.error('Failed to load tournaments.');
                  c.model.isLoading = false;
                  
              })
              .finally(() => {
           
              });
      },
      
      add() {
          const c = this

          c.model.edit = true;
          // Reset tournament data when adding new
          c.resetTournament();
      },
      
      edit(id) {
          const c = this

          const data = c.model.tournaments[`${id}`];

          console.log(data)
          
          if (!data) {
              utils.alert.error('Tournament not found.');
              return;
          }
          
          // Toggle edit mode if clicking same tournament
          if (c.model.tournament.id === id) {
              c.model.edit = !c.model.edit;
              if (!c.model.edit) {
                  c.resetTournament();
              }
              return;
          }
          
          c.model.edit = true;
          c.model.tournament = {
              id: id,
              active: data.active || false,
              name: data.name || '',
              description: data.description || '',
              players: data.bracket || null,
              selectedOption: data.rules || '',
              battleOption: data.battleOption || null,
              autobattle: data.autobattle || false,
              multipleBattle: data.multiple || false,
              faction: data.faction || false,
              innerFaction: data.innerFaction || false,
              universalFaction: data.universalFaction || false
          };
      },
      
      save() {
          const c = this

          const data = c.model.tournament;
          
          // Validation
          const validationErrors = c.validateTournament(data);
          if (validationErrors.length > 0) {
              validationErrors.forEach(error => utils.alert.error(error));
              return;
          }
          
          c.model.isLoading = true;
          
          tournamentService.save(data)
              .then((response) => {
                  if (response.data.status === 400) {
                      utils.alert.error(response.data.message);
                      return;
                  }
                  
                  c.sendMessage('tournament_on');
                  c.reset();
                  c.get();
                  
                  utils.alert.success('Tournament saved successfully!');
                  c.$root.$emit('tournament_saved', data);
              })
              .catch((error) => {
                  console.error('Error saving tournament:', error);
                  utils.alert.error('Failed to save tournament.');
              })
              .finally(() => {
                  c.model.isLoading = false;
              });
      },
      
      validateTournament(data) {
          const c = this

          const errors = [];
          
          if (!data.name || data.name.trim() === '') {
              errors.push('Tournament name is required');
          }
          
          if (!data.description || data.description.trim() === '') {
              errors.push('Tournament description is required');
          }
          
          if (!data.players) {
              errors.push('Number of players is required');
          }
          
          if (!data.selectedOption) {
              errors.push('Tournament rules option is required');
          }
          
          if (!data.battleOption) {
              errors.push('Battle option is required');
          }
          
          return errors;
      },
      
      sendMessage(state) {
          const c = this

          if (!c.ws || c.ws.readyState !== WebSocket.OPEN) {
              console.warn('WebSocket is not connected');
              return;
          }
          
          try {
              const messageData = {
                  to: utils.cookies.get('user_id'),
                  channelId: utils.cookies.get('channelId'),
                  message: state,
                  data: c.model.tournament
              };
              
              c.ws.send(JSON.stringify(messageData));
          } catch (error) {
              console.error('Error sending WebSocket message:', error);
          }
      },
      
      resetTournament() {
          const c = this
          
          c.model.tournament = {
              active: false,
              name: null,
              description: null,
              players: null,
              selectedOption: '',
              battleOption: null,
              autobattle: false,
              multipleBattle: false,
              faction: false,
              innerFaction: false,
              universalFaction: false
          };
      },
      
      reset() {
          const c = this

          c.model.edit = false;
          c.resetTournament();
      },
      
      handleInputChange(updatedModel) {
          const c = this
          // Handle the input change from TournamentForm
          if (updatedModel && updatedModel.tournament) {
              c.model.tournament = { ...c.model.tournament, ...updatedModel.tournament };
          }
      },
      
     
      selectedBracket() {
          const c = this
      
          console.log('Bracket selected:', c.model.tournament.players);
      },
      
      selectedOption() {
          const c = this
          
          console.log('Option selected:', c.model.tournament.selectedOption);
      },
      
      selectedBattleOptions() {
          const c = this

          console.log('Battle option selected:', c.model.tournament.battleOption);
      },
      
      changeFactionUniversal() {
          const c = this
          c.model.tournament.innerFaction = false;
      },
      
      changeFactionInner() {
          const c = this
          c.model.tournament.universalFaction = false;
      },
      
      disableFaction() {
          const c = this
          c.model.tournament.universalFaction = false;
          c.model.tournament.innerFaction = false;
      }
  }
});